import { EXPORT_CANCELLED, POLL_INTERVAL, POLL_MAX_ATTEMPTS } from '../../common/constants/exports'
import { buildEntriesExportsConditionsSpec } from '../../common/models/exports'
import { api, combineConditionsWithExpression, downloadFromUrl } from '../../common/services/api'
import { getToastConfig } from '../../common/utils/exports'
import { withToastDisplay } from '../../common/utils/toast'
import { CancelToken } from 'axios'


export const cancelExport = async (formId, exportId) => {
  if (exportId) {
    const patchBody = {
      'state': 'cancelled'
    }

    try {
      await api.patch(`/forms/${formId}/entries/requests/exports/${exportId}`, patchBody)
    } catch (e) {
      // This will only really fail if the promise is already resolved or
      // if the export has already completed
      // No-op
    }
  }
}

export const startEntriesExport = (form, entrySpec, type) => (
  async (dispatch, getState) => {
    const { exports: { inProgress }} = getState()
    if (inProgress) {
      dispatch({ type: 'OPEN_MODAL', data: 'export-in-progress-modal' })
    } else {
      const { id } = form
      let rejectPromise
      let exportId
      let _timer

      const assignRejectionProps = (reject, id, timer = undefined) => {
        rejectPromise = reject
        exportId = id
        _timer = timer
      }

      const conditionsSpec = buildEntriesExportsConditionsSpec(entrySpec)
      const exportBody = {
        'conditions': combineConditionsWithExpression(conditionsSpec.conditions, conditionsSpec.expression) || '',
        formId: id,
        type
      }

      const handleCancelExport = () => {
        clearTimeout(_timer)
        rejectPromise(EXPORT_CANCELLED)
        cancelExport(id, exportId)
      }

      const toastConfig = getToastConfig(handleCancelExport)
      await dispatch(startExport(toastConfig, exportBody, assignRejectionProps))
    }
  }
)

export const startExport = (toastConfig, exportBody, assignRejectionProps = () => {}) => (
  async (dispatch) => {
    dispatch({ type:'SET_EXPORT_IN_PROGRESS', data: { inProgress: true }})

    await withToastDisplay(dispatch, toastConfig, async () => {
      await exportHandler(dispatch, exportBody, assignRejectionProps)
    })
  }
)

export const exportHandler = async (dispatch, requestBody, assignRejectionProps) => {
  try {
    const { data: { id: exportId }} = await api.post(
      `/forms/${requestBody.formId}/entries/requests/exports`,
      requestBody,
      {
        cancelToken: new CancelToken((cancel) => {
          assignRejectionProps(cancel)
        })
      }
    )
    const exportUrl = await pollExportStatus(requestBody.formId, exportId, assignRejectionProps)
    dispatch({ type: 'SET_EXPORT_URL', data: { exportUrl: exportUrl }})
    if (exportUrl) {
      downloadFromUrl(exportUrl)
    }
  } finally {
    dispatch({ type: 'CLOSE_MODAL_TYPE', data: 'export-in-progress-modal' })
    dispatch({ type:'SET_EXPORT_IN_PROGRESS', data: { inProgress: false }})
  }
}

const pollExportStatus = async (formId, exportId, assignRejectionProps) => (
  new Promise((resolve, reject) => {
    let count = 0
    let timer

    const poll = async () => {
      const { data } = await api.get(`/forms/${formId}/entries/requests/exports/${exportId}`)
      if (data.artifactMetadata.url) {
        resolve(data.artifactMetadata.url)
      } else if (data.state === 'cancelled') {
        // If the export was cancelled it's possible it's between polling attempts
        // this prevents it from continuing to poll in that case
        resolve()
      } else if (data.state === 'errored'){
        reject('Export failed to run')
      } else if (count < POLL_MAX_ATTEMPTS) {
        count++
        timer = setTimeout(() => {
          poll()
        }, POLL_INTERVAL)
        assignRejectionProps(reject, exportId, timer)
      } else {
        reject('Export timed out')
      }
    }
    poll()
  })
)
